import { Controller } from "@hotwired/stimulus";

/**
 * Syncs the selected subscription type from the selection form to the coupon form's hidden field.
 * This ensures that when a user selects a subscription type and then applies a coupon,
 * the selection is preserved after the page reloads.
 */
export default class extends Controller {
  static targets = ["hiddenField", "selectionForm"];

  syncSelection(event) {
    // Only sync when a radio button for subscription_type_id changes
    const input = event.target;
    if (input.type !== "radio" || !input.name.endsWith("[subscription_type_id]")) {
      return;
    }

    // Update the hidden field in the coupon form with the selected value
    if (this.hasHiddenFieldTarget) {
      this.hiddenFieldTarget.value = input.value;
    }
  }
}
